import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { obtenerProveedores, obtenerProveedoresOpto11 } from '../../../state/actions/creators/proveedores.actioncreator';
import { obtenerPedidosLc, realizarPedidoLc } from '../../../state/actions/creators/pedidoslc.actioncreator';
import BotonesPedidolc from '../components/pedidoslc/botonesPedidoslc';
import FiltrosPedidolc from '../components/pedidoslc/filtrosPedidoslc';
import TablePedidoslc from '../components/pedidoslc/tablePedidoslc';
import { PEDIDOSLC_REALIZAR_PEDIDO_REQUEST } from '../../../state/actions/constants/pedidoslc.constants';
import SelectorTienda from '../../shared/components/dataEntry/SelectorTienda.dataentry';
import { Box } from '../../shared/components';

export default function TablePedidoslcList() {
  const dispatch = useDispatch();
  const pageSize = 5;
  const proveedores = useSelector(state => state.proveedoresWorkspace.proveedores);
  const { detallesPedidos, totalDetallesPedidos, errorPedido } = useSelector(state => state.pedidoslcWorkspace);
  const { proveedoresOpto11 } = useSelector(state => state.proveedoresWorkspace);
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const sagas = useSelector(state => state.sagas);
  const [selectedProveedor, setSelectedProveedor] = useState();
  const [selectedTienda, setSelectedTienda] = useState();
  const [page, setPage] = useState(1);
  const { OBTENER_PROVEEDORES, PEDIDOSLC_OBTENER_PEDIDOS, PEDIDOSLC_REALIZAR_PEDIDO, RELOAD_PEDIDOS_LC } = sagas;

  const proveedoresFiltrados = proveedoresOpto11 ? proveedores.filter((e) => {
    const provOpto = proveedoresOpto11.find(opto => opto.codigo === e.codigo);
    return e.codigo !== null && provOpto;
  }) : [];

  const esperandoRespuestaPedido = PEDIDOSLC_REALIZAR_PEDIDO?.running;
  const respuestaPedidoFinalizada = PEDIDOSLC_REALIZAR_PEDIDO?.success || errorPedido !== null;
  const respuestaProveedoresFinalizada = OBTENER_PROVEEDORES?.success;

  useEffect(() => {
    if (!proveedores || proveedores.length === 0) {
      dispatch(obtenerProveedores());
    }
    if (!proveedoresOpto11 || proveedores.length === 0) {
      dispatch(obtenerProveedoresOpto11());
    }
    if (!selectedTienda) {
      setSelectedTienda(tiendaId);
    }
  }, []);
  useEffect(() => {
    if (proveedoresFiltrados && proveedoresFiltrados.length !== 0) {
      setSelectedProveedor(proveedoresFiltrados[0].id);
    }
  }, [proveedoresFiltrados]);

  useEffect(() => {
    if (selectedProveedor && selectedTienda !== undefined && selectedTienda !== null && respuestaProveedoresFinalizada) {
      dispatch(obtenerPedidosLc({
        proveedorId: selectedProveedor, tiendaId: selectedTienda, pagina: page - 1, limite: pageSize,
      }));
    }
  }, [selectedProveedor, selectedTienda, page, respuestaProveedoresFinalizada]);

  useEffect(() => {
    if (selectedProveedor && selectedTienda !== undefined && selectedTienda !== null && respuestaPedidoFinalizada) {
      dispatch(obtenerPedidosLc({
        proveedorId: selectedProveedor, tiendaId: selectedTienda, pagina: page - 1, limite: pageSize,
      }));
    }
  }, [respuestaPedidoFinalizada]);

  const filtrosPedidosLc = (
    <FiltrosPedidolc
      selectedTienda={selectedTienda}
      proveedores={proveedoresFiltrados.filter(e => e.codigo !== null)}
      selectedProveedor={selectedProveedor}
      loadingProveedores={OBTENER_PROVEEDORES?.running || !OBTENER_PROVEEDORES?.success}
      onChangeTienda={setSelectedTienda}
      onChangeProveedor={setSelectedProveedor}
    />
  );
  return (

    <Box p="16px">
      <p className="filtros-titulo-pedidoslc">Filtros </p>
      <TablePedidoslc toolbar={filtrosPedidosLc} loading={PEDIDOSLC_OBTENER_PEDIDOS?.running} data={detallesPedidos} total={totalDetallesPedidos} page={page} pageSize={pageSize} onPageChange={page => setPage(page)} />
      <BotonesPedidolc loadingPedir={esperandoRespuestaPedido} disabledPedir={!detallesPedidos || detallesPedidos.length === 0 || proveedoresFiltrados.find(e => e.id === selectedProveedor)?.codigo !== 'COVES'} onPedir={() => dispatch(realizarPedidoLc({ proveedorId: selectedProveedor, tiendaId: selectedTienda }))} />
    </Box>
  );
}
